(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var styleModeKey = 'veloraStyleMode';

  function getStyleMode() {
    try {
      return window.localStorage.getItem(styleModeKey) || document.documentElement.getAttribute('data-style-mode') || 'light';
    } catch (error) {
      return document.documentElement.getAttribute('data-style-mode') || 'light';
    }
  }

  function setStyleMode(mode) {
    var nextMode = mode === 'dark' ? 'dark' : 'light';

    document.documentElement.setAttribute('data-style-mode', nextMode);

    document.querySelectorAll('[data-style-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(nextMode === 'light'));
      button.setAttribute('aria-label', nextMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
    });

    document.querySelectorAll('[data-style-mode-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-style-mode-choice') === nextMode));
    });

    try {
      window.localStorage.setItem(styleModeKey, nextMode);
    } catch (error) {
      return;
    }
  }

  function getStyleModeSwitcher() {
    return document.querySelector('[data-style-mode-switch]');
  }

  function setStyleModePanel(open) {
    var switcher = getStyleModeSwitcher();

    if (!switcher) {
      return;
    }

    var trigger = switcher.querySelector('[data-style-mode-trigger]');
    var panel = switcher.querySelector('[data-style-mode-panel]');

    if (!trigger || !panel) {
      return;
    }

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  var langKey = 'veloraLang';
  var defaultLang = 'en';

  function getGoogTransCookieLang() {
    var match = document.cookie.match(/(?:^|;\s*)googtrans=\/en\/([a-zA-Z-]+)/);
    return match ? match[1] : null;
  }

  function getCurrentLang() {
    try {
      var stored = window.localStorage.getItem(langKey);

      if (stored) {
        return stored;
      }
    } catch (error) {
      // ignore storage errors
    }

    return getGoogTransCookieLang() || defaultLang;
  }

  function setGoogTransCookie(lang) {
    var host = window.location.hostname;
    var expired = 'googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

    document.cookie = expired;
    document.cookie = expired + ' domain=' + host + ';';

    if (lang && lang !== defaultLang) {
      document.cookie = 'googtrans=/en/' + lang + '; path=/;';
      document.cookie = 'googtrans=/en/' + lang + '; path=/; domain=' + host + ';';
    }
  }

  function getLangSwitcher() {
    return document.querySelector('[data-lang-switch]');
  }

  function setLangPanel(open) {
    var switcher = getLangSwitcher();

    if (!switcher) {
      return;
    }

    var trigger = switcher.querySelector('[data-lang-trigger]');
    var panel = switcher.querySelector('[data-lang-panel]');

    if (!trigger || !panel) {
      return;
    }

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  function syncLangChoices(lang) {
    document.querySelectorAll('[data-lang-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-lang-choice') === lang));
    });
  }

  function setLang(lang) {
    var nextLang = lang || defaultLang;
    var storedCookieLang = getGoogTransCookieLang();
    var alreadyActive = nextLang === defaultLang ? !storedCookieLang : storedCookieLang === nextLang;

    try {
      window.localStorage.setItem(langKey, nextLang);
    } catch (error) {
      // ignore storage errors
    }

    syncLangChoices(nextLang);

    if (alreadyActive) {
      return;
    }

    setGoogTransCookie(nextLang);
    window.location.reload();
  }

  function getMenuToggle() {
    return document.querySelector('[data-menu-toggle], .header__menu-button');
  }

  function getMobileMenu() {
    return document.querySelector('[data-mobile-menu]');
  }

  function getMenuDrawer() {
    return document.querySelector('[data-menu-drawer]');
  }

  function getMenuScrim() {
    return document.querySelector('.mobile-menu-scrim');
  }

  function getDesktopCategoryMenu() {
    return document.querySelector('[data-desktop-category-menu]');
  }

  function isDesktopMenu() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function isPointInRect(x, y, rect, padding) {
    return (
      x >= rect.left - padding &&
      x <= rect.right + padding &&
      y >= rect.top - padding &&
      y <= rect.bottom + padding
    );
  }

  function isPointInDesktopMenuArea(x, y) {
    var menuToggle = getMenuToggle();
    var mobileMenu = getMobileMenu();
    var menuDrawer = getMenuDrawer();

    if (!menuToggle || !mobileMenu) {
      return false;
    }

    var toggleRect = menuToggle.getBoundingClientRect();
    var menuRect = mobileMenu.getBoundingClientRect();
    var drawerRect = menuDrawer ? menuDrawer.getBoundingClientRect() : null;

    if (
      isPointInRect(x, y, toggleRect, 14) ||
      isPointInRect(x, y, menuRect, 8) ||
      (drawerRect && isPointInRect(x, y, drawerRect, 12))
    ) {
      return true;
    }

    var bridgeTop = Math.min(toggleRect.bottom, menuRect.top) - 18;
    var bridgeBottom = Math.max(toggleRect.bottom, menuRect.top) + 34;
    var bridgeLeft = Math.min(toggleRect.left, menuRect.left) - 34;
    var bridgeRight = Math.max(toggleRect.right, menuRect.right) + 34;

    return x >= bridgeLeft && x <= bridgeRight && y >= bridgeTop && y <= bridgeBottom;
  }

  var desktopMenuCloseTimer = null;
  var desktopPointer = { x: 0, y: 0 };
  var desktopCategoryCloseTimer = null;
  var desktopCategoryPointer = { x: 0, y: 0 };

  function clearDesktopMenuCloseTimer() {
    if (desktopMenuCloseTimer) {
      window.clearTimeout(desktopMenuCloseTimer);
      desktopMenuCloseTimer = null;
    }
  }

  function scheduleDesktopMenuClose() {
    if (desktopMenuCloseTimer) {
      return;
    }

    desktopMenuCloseTimer = window.setTimeout(function () {
      desktopMenuCloseTimer = null;

      if (!isPointInDesktopMenuArea(desktopPointer.x, desktopPointer.y)) {
        setMobileMenu(false);
      }
    }, 140);
  }

  function clearDesktopCategoryCloseTimer() {
    if (desktopCategoryCloseTimer) {
      window.clearTimeout(desktopCategoryCloseTimer);
      desktopCategoryCloseTimer = null;
    }
  }

  function isPointInDesktopCategoryArea(x, y) {
    var menu = getDesktopCategoryMenu();

    if (!menu) {
      return false;
    }

    var toggle = menu.querySelector('[data-desktop-category-toggle]');
    var panel = menu.querySelector('[data-desktop-category-panel]');

    if (!toggle || !panel) {
      return false;
    }

    var toggleRect = toggle.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();

    if (isPointInRect(x, y, toggleRect, 18) || isPointInRect(x, y, panelRect, 10)) {
      return true;
    }

    var bridgeTop = Math.min(toggleRect.bottom, panelRect.top) - 8;
    var bridgeBottom = Math.max(toggleRect.bottom, panelRect.top) + 36;
    var bridgeLeft = Math.min(toggleRect.left, panelRect.left) - 44;
    var bridgeRight = Math.max(toggleRect.right, panelRect.right) + 44;

    return x >= bridgeLeft && x <= bridgeRight && y >= bridgeTop && y <= bridgeBottom;
  }

  function setDesktopCategoryMenu(isOpen) {
    var menu = getDesktopCategoryMenu();

    if (!menu) {
      return;
    }

    var toggle = menu.querySelector('[data-desktop-category-toggle]');

    if (isOpen) {
      clearDesktopCategoryCloseTimer();
    }

    menu.classList.toggle('is-open', isOpen);

    if (toggle) {
      toggle.setAttribute('aria-expanded', String(isOpen));
    }
  }

  function scheduleDesktopCategoryClose() {
    if (desktopCategoryCloseTimer) {
      return;
    }

    desktopCategoryCloseTimer = window.setTimeout(function () {
      desktopCategoryCloseTimer = null;

      if (!isPointInDesktopCategoryArea(desktopCategoryPointer.x, desktopCategoryPointer.y)) {
        setDesktopCategoryMenu(false);
      }
    }, 180);
  }

  function setMobileMenu(isOpen) {
    var mobileMenu = getMobileMenu();
    var menuToggle = getMenuToggle();
    var menuDrawer = getMenuDrawer();
    var menuScrim = getMenuScrim();

    if (!mobileMenu && !menuDrawer) {
      return;
    }

    if (isOpen) {
      clearDesktopMenuCloseTimer();
    }

    if (menuDrawer) {
      menuDrawer.open = isOpen;
    }

    if (mobileMenu) {
      mobileMenu.classList.toggle('is-open', isOpen);
    }

    document.body.classList.toggle('mobile-menu-open', isOpen);

    if (menuScrim) {
      menuScrim.classList.toggle('is-open', isOpen);
    }

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    }
  }

  document.addEventListener('click', function (event) {
    var liveDemoLink = event.target.closest('[data-live-demo-link]');

    if (!liveDemoLink) {
      return;
    }

    var demoUrl = liveDemoLink.getAttribute('href');

    if (!demoUrl || demoUrl.charAt(0) === '#') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var openedWindow = window.open(demoUrl, '_blank');

    if (openedWindow) {
      openedWindow.opener = null;
    } else {
      window.location.href = demoUrl;
    }
  }, true);

  document.addEventListener('click', function (event) {
    var styleToggle = event.target.closest('[data-style-toggle]');
    var styleModeTrigger = event.target.closest('[data-style-mode-trigger]');
    var styleModeChoice = event.target.closest('[data-style-mode-choice]');
    var styleModeClose = event.target.closest('[data-style-mode-close]');
    var langTrigger = event.target.closest('[data-lang-trigger]');
    var langChoice = event.target.closest('[data-lang-choice]');
    var langClose = event.target.closest('[data-lang-close]');
    var menuToggle = event.target.closest('[data-menu-toggle]');
    var menuCloser = event.target.closest('[data-menu-close]');
    var submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    var menuLink = event.target.closest('a[href^="#"], [data-mobile-menu] a');

    if (styleModeTrigger) {
      var stylePanel = getStyleModeSwitcher() ? getStyleModeSwitcher().querySelector('[data-style-mode-panel]') : null;
      event.preventDefault();
      setStyleModePanel(stylePanel ? stylePanel.hidden : true);
      return;
    }

    if (styleModeChoice) {
      event.preventDefault();
      setStyleMode(styleModeChoice.getAttribute('data-style-mode-choice'));
      setStyleModePanel(false);
      return;
    }

    if (styleModeClose) {
      event.preventDefault();
      setStyleModePanel(false);
      return;
    }

    if (langTrigger) {
      var langSwitcher = getLangSwitcher();
      var langPanel = langSwitcher ? langSwitcher.querySelector('[data-lang-panel]') : null;
      event.preventDefault();
      setLangPanel(langPanel ? langPanel.hidden : true);
      return;
    }

    if (langChoice) {
      event.preventDefault();
      setLang(langChoice.getAttribute('data-lang-choice'));
      setLangPanel(false);
      return;
    }

    if (langClose) {
      event.preventDefault();
      setLangPanel(false);
      return;
    }

    if (styleToggle) {
      event.preventDefault();
      setStyleMode(getStyleMode() === 'light' ? 'dark' : 'light');
      return;
    }

    if (menuToggle) {
      var mobileMenu = getMobileMenu();
      event.preventDefault();

      if (isDesktopMenu()) {
        setMobileMenu(true);
        return;
      }

      setMobileMenu(!(mobileMenu && mobileMenu.classList.contains('is-open')));
      return;
    }

    if (menuCloser) {
      event.preventDefault();
      setMobileMenu(false);
      return;
    }

    if (submenuToggle) {
      var submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));

      if (submenu) {
        var isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', String(!isOpen));

        if (isOpen) {
          submenu.setAttribute('hidden', 'hidden');
        } else {
          submenu.removeAttribute('hidden');
        }
      }

      return;
    }

    if (menuLink) {
      var openMenu = getMobileMenu();

      if (openMenu && openMenu.classList.contains('is-open')) {
        setMobileMenu(false);
      }
    }

    if (!event.target.closest('[data-style-mode-switch]')) {
      setStyleModePanel(false);
    }

    if (!event.target.closest('[data-lang-switch]')) {
      setLangPanel(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMobileMenu(false);
      setDesktopCategoryMenu(false);
      setStyleModePanel(false);
      setLangPanel(false);
    }
  });

  document.addEventListener('mouseover', function (event) {
    if (!isDesktopMenu()) {
      return;
    }

    if (event.target.closest('[data-desktop-category-menu]')) {
      setDesktopCategoryMenu(true);
      return;
    }

    if (event.target.closest('[data-menu-toggle], [data-menu-drawer]')) {
      setMobileMenu(true);
    }
  });

  document.addEventListener('mousemove', function (event) {
    var menuDrawer = getMenuDrawer();

    if (!isDesktopMenu() || !menuDrawer || !menuDrawer.open) {
      return;
    }

    desktopPointer.x = event.clientX;
    desktopPointer.y = event.clientY;

    if (isPointInDesktopMenuArea(event.clientX, event.clientY)) {
      clearDesktopMenuCloseTimer();
      return;
    }

    scheduleDesktopMenuClose();
  });

  document.addEventListener('mousemove', function (event) {
    var categoryMenu = getDesktopCategoryMenu();

    if (!isDesktopMenu() || !categoryMenu || !categoryMenu.classList.contains('is-open')) {
      return;
    }

    desktopCategoryPointer.x = event.clientX;
    desktopCategoryPointer.y = event.clientY;

    if (isPointInDesktopCategoryArea(event.clientX, event.clientY)) {
      clearDesktopCategoryCloseTimer();
      return;
    }

    scheduleDesktopCategoryClose();
  });

  window.addEventListener('resize', function () {
    if (!isDesktopMenu()) {
      setMobileMenu(false);
      setDesktopCategoryMenu(false);
    }
  });

  document.addEventListener('toggle', function (event) {
    if (!event.target.matches || !event.target.matches('[data-menu-drawer]')) {
      return;
    }

    var menuDrawer = event.target;
    var drawerMenu = menuDrawer.querySelector('[data-mobile-menu]');
    var drawerScrim = menuDrawer.querySelector('.mobile-menu-scrim');
    var isOpen = menuDrawer.open;

    if (drawerMenu) {
      drawerMenu.classList.toggle('is-open', isOpen);
    }

    if (drawerScrim) {
      drawerScrim.classList.toggle('is-open', isOpen);
    }

    document.body.classList.toggle('mobile-menu-open', isOpen);
  }, true);

  setStyleMode(getStyleMode());
  syncLangChoices(getCurrentLang());

  var collectionGrid = document.querySelector('[data-collection-product-grid]');
  var collectionViewButtons = document.querySelectorAll('[data-collection-view]');

  if (collectionGrid && collectionViewButtons.length) {
    var storedCollectionView = 'grid';

    try {
      storedCollectionView = window.localStorage.getItem('veloraCollectionView') || 'grid';
    } catch (error) {
      storedCollectionView = 'grid';
    }

    function setCollectionView(view) {
      var isListView = view === 'list';

      collectionGrid.classList.toggle('is-list-view', isListView);

      collectionViewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-collection-view') === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      try {
        window.localStorage.setItem('veloraCollectionView', view);
      } catch (error) {
        return;
      }
    }

    collectionViewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setCollectionView(button.getAttribute('data-collection-view') || 'grid');
      });
    });

    setCollectionView(storedCollectionView);
  }

  document.querySelectorAll('[data-template-toolbar]').forEach(function (toolbar) {
    var templateSection = toolbar.closest('.shop-by-category');
    var sortButtons = toolbar.querySelectorAll('[data-template-sort]');
    var viewButtons = toolbar.querySelectorAll('[data-template-view]');
    var countElement = toolbar.querySelector('[data-template-sort-count]');
    var sortDetails = toolbar.querySelector('[data-template-sort-details]');

    if (!templateSection) {
      return;
    }

    function getTemplateGrids() {
      return Array.prototype.slice.call(templateSection.querySelectorAll('[data-template-grid]'));
    }

    function getActiveTemplateGrid() {
      return templateSection.querySelector('.template-tab-panel.is-active [data-template-grid]') || templateSection.querySelector('[data-template-grid]');
    }

    function getSortCards(grid) {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-sort-card]'));
    }

    function prepareSortCards() {
      getTemplateGrids().forEach(function (grid) {
        getSortCards(grid).forEach(function (card, index) {
          if (!card.hasAttribute('data-sort-index')) {
            card.setAttribute('data-sort-index', String(index));
          }
        });
      });
    }

    function getNumber(card, attribute) {
      return Number(card.getAttribute(attribute)) || 0;
    }

    function sortGrid(grid, mode) {
      var cards = getSortCards(grid);

      cards.sort(function (cardA, cardB) {
        var originalA = getNumber(cardA, 'data-sort-index');
        var originalB = getNumber(cardB, 'data-sort-index');
        var titleA = (cardA.getAttribute('data-sort-title') || '').toLowerCase();
        var titleB = (cardB.getAttribute('data-sort-title') || '').toLowerCase();
        var priceA = getNumber(cardA, 'data-sort-price');
        var priceB = getNumber(cardB, 'data-sort-price');
        var dateA = getNumber(cardA, 'data-sort-date');
        var dateB = getNumber(cardB, 'data-sort-date');
        var salesA = getNumber(cardA, 'data-sort-sales');
        var salesB = getNumber(cardB, 'data-sort-sales');

        if (mode === 'title-asc') {
          return titleA.localeCompare(titleB);
        }

        if (mode === 'title-desc') {
          return titleB.localeCompare(titleA);
        }

        if (mode === 'price-asc') {
          return priceA - priceB;
        }

        if (mode === 'price-desc') {
          return priceB - priceA;
        }

        if (mode === 'date-asc') {
          return dateA - dateB || originalA - originalB;
        }

        if (mode === 'date-desc') {
          return dateB - dateA || originalA - originalB;
        }

        if (mode === 'selling') {
          return salesB - salesA || originalA - originalB;
        }

        return originalA - originalB;
      });

      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function updateTemplateCount() {
      var activeGrid = getActiveTemplateGrid();

      if (activeGrid && countElement) {
        countElement.textContent = String(getSortCards(activeGrid).length);
      }
    }

    function setTemplateSort(mode, selectedButton) {
      getTemplateGrids().forEach(function (grid) {
        sortGrid(grid, mode);
      });

      sortButtons.forEach(function (button) {
        var isActive = button === selectedButton;
        var check = button.querySelector('.collection-sort__check');

        button.classList.toggle('is-active', isActive);
        button.toggleAttribute('aria-current', isActive);

        if (check) {
          check.textContent = isActive ? String.fromCharCode(10003) : '';
        }
      });

      if (sortDetails) {
        sortDetails.open = false;
      }

      updateTemplateCount();
    }

    function setTemplateView(view) {
      var isListView = view === 'list';

      getTemplateGrids().forEach(function (grid) {
        grid.classList.toggle('is-list-view', isListView);
      });

      viewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-template-view') === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    prepareSortCards();
    updateTemplateCount();

    sortButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTemplateSort(button.getAttribute('data-template-sort') || 'featured', button);
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTemplateView(button.getAttribute('data-template-view') || 'grid');
      });
    });

    templateSection.querySelectorAll('[data-template-tab]').forEach(function (tabButton) {
      tabButton.addEventListener('click', function () {
        window.setTimeout(updateTemplateCount, 0);
      });
    });
  });

  document.querySelectorAll('[data-ad-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-ad-slide]');
    var dots = slider.querySelectorAll('[data-ad-dot]');
    var prevButton = slider.querySelector('[data-ad-prev]');
    var nextButton = slider.querySelector('[data-ad-next]');
    var currentIndex = 0;
    var timer = null;
    var interval = Number(slider.getAttribute('data-interval')) || 5000;
    var shouldAutoplay = slider.getAttribute('data-autoplay') === 'true';

    if (slides.length <= 1) {
      return;
    }

    function showSlide(nextIndex) {
      currentIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        var isActive = index === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach(function (dot, index) {
        var isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!shouldAutoplay) {
        return;
      }

      stopAutoplay();
      timer = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, interval);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        showSlide(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        showSlide(index);
        startAutoplay();
      });
    });


    showSlide(0);
    startAutoplay();
  });

  document.querySelectorAll('[data-nav-dropdown-item]').forEach(function (dropdownItem) {
    var dropdownToggle = dropdownItem.querySelector('[data-nav-dropdown-toggle]');

    if (!dropdownToggle) {
      return;
    }

    dropdownToggle.addEventListener('click', function () {
      var isOpen = dropdownItem.classList.toggle('is-open');
      dropdownToggle.setAttribute('aria-expanded', String(isOpen));
    });

    dropdownItem.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!dropdownItem.contains(event.target)) {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });

    dropdownToggle.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownToggle.focus();
      }
    });
  });

  var mainImage = document.querySelector('[data-product-main-image]');
  var thumbnails = document.querySelectorAll('[data-product-thumbnail]');

  if (mainImage && thumbnails.length) {
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var nextImage = thumbnail.getAttribute('data-image');
        if (nextImage) {
          mainImage.setAttribute('src', nextImage);
        }
      });
    });
  }

  document.querySelectorAll('.product-main').forEach(function (productSection) {
    var variantSelect = productSection.querySelector('[data-product-variant-select]');
    var variantsScript = productSection.querySelector('[data-product-variants-json]');
    var price = productSection.querySelector('[data-product-price]');
    var comparePrice = productSection.querySelector('[data-product-compare-price]');
    var discount = productSection.querySelector('[data-product-discount]');
    var submitButton = productSection.querySelector('[data-product-submit]');

    if (!variantSelect || !variantsScript) {
      return;
    }

    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      var currency = productSection.getAttribute('data-product-currency') || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + ' ' + currency;
      }
    }

    variantSelect.addEventListener('change', function () {
      var selectedId = String(variantSelect.value);
      var variant = variants.find(function (item) { return String(item.id) === selectedId; });
      if (!variant) return;

      if (price) price.textContent = formatMoney(variant.price);

      var onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      if (comparePrice) {
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (discount) {
        discount.hidden = !onSale;
        if (onSale) {
          var savings = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
          discount.textContent = 'Save ' + savings + '%';
        } else {
          discount.textContent = '';
        }
      }
      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? (productSection.getAttribute('data-add-to-cart-label') || 'Add to Cart') : (productSection.getAttribute('data-sold-out-label') || 'Sold out');
      }
    });
  });

  document.querySelectorAll('[data-template-tabs]').forEach(function (tabs) {
    var tabButtons = tabs.querySelectorAll('[data-template-tab]');
    var tabPanels = tabs.querySelectorAll('[data-template-panel]');

    function activateTab(nextButton, shouldScroll) {
      var targetPanelId = nextButton.getAttribute('aria-controls');

      tabButtons.forEach(function (button) {
        var isActive = button === nextButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach(function (panel) {
        var isActive = panel.id === targetPanelId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });

      if (shouldScroll) {
        var templateSection = tabs.closest('#shop-by-category');
        if (templateSection) {
          templateSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    function activateCategoryFromHash() {
      if (window.location.hash.indexOf('#category-') !== 0 && window.location.hash.indexOf('#template-') !== 0) {
        return;
      }

      var category = window.location.hash.replace('#category-', '').replace('#template-', '');
      var nextButton = tabs.querySelector('[data-template-tab][data-template-category="' + category + '"]');

      if (nextButton) {
        activateTab(nextButton, true);
      }
    }

    tabButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activateTab(button);
        var category = button.getAttribute('data-template-category');
        if (category && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#category-' + category);
        } else if (category) {
          window.location.hash = 'category-' + category;
        }
      });

      button.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = index + 1 >= tabButtons.length ? 0 : index + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = index - 1 < 0 ? tabButtons.length - 1 : index - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabButtons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabButtons[nextIndex].focus();
        activateTab(tabButtons[nextIndex]);
      });
    });

    activateCategoryFromHash();
    window.addEventListener('hashchange', activateCategoryFromHash);
  });

  // Scroll-triggered reveal animations for section headings, cards, and stat/benefit blocks.
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      return;
    }

    var revealTargets = document.querySelectorAll(
      '.section-heading, .metric, .prop-card, .compatibility-item, .faq-item, ' +
      '.hero__benefits, .theme-bundle__panel, .theme-newsletter__panel, ' +
      '.see-action__copy, .see-action__preview, .cta-panel, .product-card, ' +
      '.shop-by-category__intro, .review-card'
    );

    if (!revealTargets.length) {
      return;
    }

    var delayCounters = new WeakMap();

    revealTargets.forEach(function (el) {
      var parent = el.parentElement;
      var count = parent ? (delayCounters.get(parent) || 0) : 0;
      var delay = Math.min(count, 5) * 90;

      el.style.setProperty('--reveal-delay', delay + 'ms');
      el.classList.add('reveal-on-scroll');

      if (parent) {
        delayCounters.set(parent, count + 1);
      }
    });

    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    revealTargets.forEach(function (el) {
      revealObserver.observe(el);
    });
  })();

})();
